module.exports = __webpack_public_path__ + "static/media/grid_screen_5.c2ac16dd.jpg";